import CommonCss from "lib/common/style.module.scss";

import { AutoTooltip } from "lib/common";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import DocumentPaymentTypes from "const/DocumentPaymentTypes";
import Documents from "utils/Documents";
import Money from "utils/Money";
import React from "react";

const AmountCell = ({ status, paymentType, amountVatRates, amountBase, amountVat, amountCorrection, currency }) => {
  const buyPayment = paymentType === DocumentPaymentTypes.BUY;

  if (status === DataStatuses.TO_EXTRACT) return Constants.EMPTY_PLACEHOLDER;

  const value = Documents.getAmountData(amountVatRates, amountBase, amountVat, amountCorrection).total;

  const content = Money.toMoneyString(value, currency);

  return (
    <AutoTooltip
      active={value !== undefined}
      className={paymentType && value ? CommonCss.coloredNumber : ""}
      data-negative={buyPayment ? "" : undefined}>
      {content}
    </AutoTooltip>
  );
};

export default React.memo(AmountCell);
